const DEFAULT_MESSAGE = 'Unauthorized user access';
const UNAUTHORIZED_ERROR_NAME = 'UnauthorizedError';
export class UnauthorizedError extends Error {
    constructor(message) {
        super(message || DEFAULT_MESSAGE);
        this.name = UNAUTHORIZED_ERROR_NAME;
        Object.setPrototypeOf(this, UnauthorizedError.prototype);
    }
}
UnauthorizedError.NAME = UNAUTHORIZED_ERROR_NAME;
//# sourceMappingURL=UnauthorizedError.js.map